// extracted by mini-css-extract-plugin
module.exports = {"frame":"image-module--frame--1qKyq","thumbnail":"image-module--thumbnail--1YKRH"};